import { IFeeTable, IVatTable } from '../ITaxesTable';
import { VatCalculatingError } from '../Errors/VatCalculatingError';
import { TaxLoaderError } from '../Errors/TaxLoaderError';
import { ITaxLoader } from './ITaxLoader';
import { HubJsonRpcRequest } from '../../../../api/HubJsonRpcRequest';
import { HubApiMethods } from '../../../../constants/HubApiMethods';
import { CurrentUser } from '../../user/currentUser';

export class TaxLoader implements ITaxLoader {
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor() {}

    public async getFee(): Promise<IFeeTable | VatCalculatingError> {
        try {
            const currentUser = CurrentUser.getInstance();
            const jsonRpcResponse = await HubJsonRpcRequest.makeRequest<IFeeTable, {suid: string, token: string}>(
                HubApiMethods.GET_FEE,
                {
                    suid: currentUser.getSuid(),
                    token: window.app.config.user_auth_token
                },
                window.app.deviceIdentifier
            );
            console.log(jsonRpcResponse);

            if ('error' in jsonRpcResponse) {
                return new TaxLoaderError(`FEE: ${jsonRpcResponse.error.message}`);
            }

            console.log('FEE From API Service', jsonRpcResponse);
            return jsonRpcResponse;
        } catch (exception) {
            return new TaxLoaderError(`Exception on getting fee rate: ${exception.message}`);
        }
    }


    public async getVat(): Promise<IVatTable | VatCalculatingError> {
        try {
            const currentUser = CurrentUser.getInstance();
            const jsonRpcResponse = await HubJsonRpcRequest.makeRequest<IVatTable, {suid: string, token: string}>(
                HubApiMethods.GET_VAT,
                {
                    suid: currentUser.getSuid(),
                    token: window.app.config.user_auth_token
                },
                window.app.deviceIdentifier
            );

            if ('error' in jsonRpcResponse) {
                return new TaxLoaderError(`Error on getting VAT from API: ${jsonRpcResponse.error.message}`);
            }

            console.log('VAT From API Service', jsonRpcResponse);
            return jsonRpcResponse;
        } catch (exception) {
            return new TaxLoaderError(`Exception on getting VAT rate: ${exception.message}`);
        }
    }
}
